import React, { useEffect, useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import ENV from '../constants/Env';

const useStyles = makeStyles(() => ({
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1400,
  },
  iframe: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    border: 'none',
    zIndex: 1500, // High enough to be above dashboard content
    backgroundColor: 'transparent',
    opacity: 1,
    transition: 'opacity 0.15s ease-in',
  },
  iframeLoading: {
    opacity: 0,
  },
}));

export default function MncsModal({ isOpen, onClose, rideId, mode, mncsId }) {
  const classes = useStyles();
  const [iframeReady, setIframeReady] = useState(false);

  const params = new URLSearchParams({
    embeddedInDashboard: 'true',
    rideId: rideId,
  });

  if (mode) params.append('mode', mode);
  if (mncsId) params.append('mncsId', mncsId);

  const mncsUrl = `${ENV.portalUrl}/mncs?${params.toString()}`;

  // Listen for postMessage events from the iframe
  useEffect(() => {
    const handleMessage = event => {
      if (event.origin !== ENV.portalUrl) {
        return;
      }

      const { data } = event;

      // When the MNCS modal closes in the portal, close this modal
      if (data.action === 'MNCS_MODAL_CLOSED') {
        onClose();
      }

      // When the MNCS modal opens, iframe is ready
      if (data.action === 'MNCS_MODAL_OPEN') {
        setIframeReady(true);
      }
    };

    window.addEventListener('message', handleMessage, false);

    return () => {
      window.removeEventListener('message', handleMessage, false);
    };
  }, [onClose]);

  // Reset iframe ready state when opening
  useEffect(() => {
    if (isOpen) {
      setIframeReady(false);
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <>
      {/* Backdrop */}
      <Box className={classes.backdrop} onClick={onClose} />

      {/* Iframe - portal's MNCS slideover will render on top of backdrop */}
      <iframe
        data-test-id="mncs-iframe"
        title="Medical Necessity Certification Statement"
        src={mncsUrl}
        className={`${classes.iframe} ${
          !iframeReady ? classes.iframeLoading : ''
        }`}
      />
    </>
  );
}
